import * as occupationSuggestor from "../objects/occupationsuggestor";
import * as siteHeader from "../objects/siteheader";
import * as siteFooter from "../objects/sitefooter";

const sh = siteHeader;
const sf = siteFooter;
const currentQuestionClassName = 'is-current';
const questionContainer = '.questioncontainer';
const currentQuestionClassIdentifier = '.' + currentQuestionClassName;
const localStorageKey = 'checkup';
const firstQuestionsId = parseInt($('.js-question[data-question-enabled="true"]').first().attr('data-question-id'), 10);
const signInQuestionId = parseInt($('.js-question[data-question-type="9"]').first().attr('data-question-id'), 10);
const currencyInputsSelector = '.js-questioninput--FreeTextCurrency input[type="tel"], .js-questioninput--MortageRepayments input[type="tel"]';
let currentQuestionIndex = 1;
let questionData: Array<QuestionData> = [];

class QuestionData {
	id: number;
	data: string;
}

function showQuestion(id: number) {
	$('.js-question').hide();
	let questionEl = $('.js-question[data-question-id="' + id + '"]');
	questionEl.show();
    questionEl.addClass(currentQuestionClassName);
    $(questionContainer).attr('class', 'questioncontainer questioncontainer--q' + id);

	let questionValueEl = questionEl.find('.js-questionvalue');
	let elHasValue = questionValueEl.val() !== '';
	if (elHasValue) {
		let nextStepEl = questionEl.find('.js-nextstep');
		nextStepEl.removeAttr('disabled');
	}

	if (id === signInQuestionId) {
		$('.js-prompt--text').html('Nearly there! Just a few more things.');
		$('.js-prompt').show();
	}

	$('.js-questioninput').focus();
}

function goToQuestion(id: number) {
	let currentQuestionEl = $('.js-question' + currentQuestionClassIdentifier);
	currentQuestionEl.hide();
	currentQuestionEl.removeClass(currentQuestionClassName);
	showQuestion(id);
}

function toggleQuestionDataValid(el: JQuery, isValid: boolean, id: number) {
	let nextStepEl = el.find('.js-nextstep');
	
	if (isValid) {
		el.find('.js-inputwrapper').removeClass('is-invalid');
		nextStepEl.removeAttr('disabled');
	} else {
		el.find('.js-inputwrapper').addClass('is-invalid');

		// add event listener
		el.off('change keyup').on('change keyup', function (event) {
			trySaveQuestionData(id, event);
		});
	}
}

function isDataValidForQuestion(data: string, id: number): boolean {
	if (!data.trim()) {
		return false;
	}

	//Check for XSS characters
	if (/[{}<>=\"]+/.test(data)) {
		return false;
	}

	let questionElem = $('.js-question[data-question-id="' + id + '"] input');
	if (questionElem.attr('pattern')) {
		return (questionElem[0] as HTMLFormElement).checkValidity();
	}
	
	return true;
}

function getResults(e: JQueryEventObject) {
	let currentQuestionEl = $('.js-question' + currentQuestionClassIdentifier);
	let currentQuestionId = parseInt(currentQuestionEl.attr('data-question-id'), 10);
	var isSignInWithTradeMe: boolean = $(e.target).hasClass('js-signinwithtm');
	
	if (trySaveQuestionData(currentQuestionId, e)) {
		$('.js-loading').show();

		var answers = localStorage.getItem(localStorageKey);
		$.ajax({
			url: '/api/checkup/result',
			type: 'POST',
			data: answers,
			contentType: "application/json;charset=utf-8",
			dataType: 'json',
			success: function (res, textStatus, xhr) {
				var resultsUrl = '/checkup/results/' + res.resultGuid;
				var location = isSignInWithTradeMe ? '/account/signin.aspx?returnUrl=' + resultsUrl : resultsUrl;

				// send them to the results page after a slight delay
				setTimeout(function () {
					window.location.href = location;
				}, 1000);
				
			},
			error: function (xhr, status, e) {
				//alert("The data could not be loaded.");
			}
		});
	}
}

function updateFirstName(name: string) {
	$('.js-question .js-question-blurb').each(function (index, elem) {
		let $elem = $(elem);
		$elem.text($elem.text().replace('{{ ClientFirstName }}', name));
	});
}


function trySaveQuestionData(id: number, e?: any): boolean {
	let questionEl = $('.js-question[data-question-id="' + id + '"]');
	let data = String((e && $(e.target).val()) || questionEl.find('.js-questionvalue').val());

	if (questionEl.find('input[type="tel"]').is(currencyInputsSelector)) {
		// sanitize the value of spaces, underscores, dashes, and letters
		data = data.replace(/[\D\s\._\-]+/g, "");
	}	

	// client side validation
	let isValid = isDataValidForQuestion(data, id);
	toggleQuestionDataValid(questionEl, isValid, id);

	// save data
	if (isValid) {
		const answer: QuestionData = { id: id, data: data };

		// Remove any existing question data items for this id
		for (var i = 0; i < questionData.length; i++) {
			if (questionData[i].id == id) {
				questionData.splice(i, 1);
				i--;
			}
		}

		questionData.push(answer);
		localStorage.setItem(localStorageKey, JSON.stringify(questionData));

		// update the first name
		if (id === 1) {
			updateFirstName(data);
		}

		// hide any visible prompt
		$('.js-prompt').hide();

		// invalidate all other answers
		questionEl.find('.js-questionvalue:not([data-choice="' + data + '"])').each(function (index, el) {
			let $el = $(el);

			// no follow ups? nothing to do
			let followUps = $el.attr('data-followup-questions');
			if (!followUps) {
				return;
			}

			let followUpCsv = followUps.split(',');
			followUpCsv.forEach(function (value, index) {
				invalidateQuestionAndChildQuestions(parseInt(value, 10));
			});
		});

		// add any follows as a result of this answer
		let followUpQuestionIdsCsv = questionEl.find('.js-questionvalue[data-choice="' + data + '"]').attr('data-followup-questions');
		if (followUpQuestionIdsCsv) {
			let followUpQuestionIds = followUpQuestionIdsCsv.split(',');

			followUpQuestionIds.forEach(function (value, index) {
				let followUpQuestionEl = $('.js-question[data-question-id="' + value + '"]');
				let isEnabled = (followUpQuestionEl.attr('data-question-enabled') == 'true');
				if (!isEnabled) {
					followUpQuestionEl.attr('data-question-enabled', 'true');
					followUpQuestionEl.insertAfter(questionEl);
					questionEl = followUpQuestionEl;
				}
			});
		}

		updateQuestionIndexes();
	}

	return isValid;
}

function invalidateQuestionAndChildQuestions(questionId: number) {
	let $el = $('.js-question[data-question-id="' + questionId + '"]');
	$el.attr('data-question-enabled', 'false');

	let answers = $el.find('.js-questionvalue');
	answers.each(function (index, followUpEl) {
		let followUps = $(followUpEl).attr('data-followup-questions');
		if (followUps) {
			let followUpCsv = followUps.split(',');

			followUpCsv.forEach(function (value, index) {
				invalidateQuestionAndChildQuestions(parseInt(value,10));
			});
		}
	});
}

function nextQuestion(e: JQueryEventObject) {
	e.preventDefault();
	
	let currentQuestionEl = $('.js-question' + currentQuestionClassIdentifier);
	let currentQuestionId = parseInt(currentQuestionEl.attr('data-question-id'), 10);

	if (trySaveQuestionData(currentQuestionId, e)) {
		currentQuestionIndex = parseInt(currentQuestionEl.attr('data-question-index'), 10);
		let nextQuestionId = parseInt(
			currentQuestionEl.nextAll('.js-question[data-question-enabled="true"]')
				.attr('data-question-id')
			, 10);

		// submit if its the last question
		if (isNaN(nextQuestionId)) {
			getResults(e);
		}

		goToQuestion(nextQuestionId);
		updateProgress(nextQuestionId);
	}

}

function updateProgress(nextQuestionId?: number) {
	// don't update progress if we've already been this far
	if (parseInt($('.js-progress').attr('data-current-question'), 10) >= currentQuestionIndex) {
		return;
	}

	let maxQuestions = $('.js-question[data-question-enabled="true"]').length;
	let currentCategoryId = $('.js-question.is-current').data('question-category-id');
	let $currentStep = $('.js-progressbarstep[data-step-number=' + currentCategoryId + ']');
	let currentProgressFillWidth = $('.js-progressbarstep-fill').width();

	// progress is expressed as a decimal rounded to 2dp for screen-readers
	let newProgress = (currentQuestionIndex / maxQuestions).toFixed(2);
	let newProgressFillWidth = 0;
	let circleWidth = $('.js-progressbarstep-circle').first().outerWidth();
	let isComplete = false;

	if (parseInt(newProgress, 10) >= 1) {
		newProgressFillWidth = $('.js-progressbarstep-progress').width(); // completed!
		isComplete = true;
	} else {
		// progress bar = progress through previous sections + progress through current section
		for (let i = 1; i <= currentCategoryId; i++) {
			let questionsSoFar = $('.js-question[data-question-enabled="true"]').filter(function () {
				return parseInt($(this).attr('data-question-category-id'), 10) < i;
			}).length;
			let questionsInCategory = $('.js-question[data-question-enabled="true"][data-question-category-id="' + i + '"]').length;
			let currentCategoryQuestionIndex = currentQuestionIndex - questionsSoFar;
			let progressInCategory = currentCategoryQuestionIndex / questionsInCategory;

			if (progressInCategory > 1) {
				progressInCategory = 1;
			}

			let $curStep = $('.js-progressbarstep[data-step-number=' + i + ']');
			let $nextStep = $('.js-progressbarstep[data-step-number=' + (i + 1) + ']');
			let currentSectionProgressWidth = 0;

			if (i == 1) {
				// first step has no left-padding
				let currentStepPadding = ($curStep.outerWidth() - $curStep.width());
				currentSectionProgressWidth = (($curStep.width() / 2) + currentStepPadding) + ($nextStep.outerWidth() / 2);
			} else {
				currentSectionProgressWidth = ($curStep.outerWidth() / 2) + ($nextStep.outerWidth() / 2);
			}

			newProgressFillWidth += currentSectionProgressWidth * progressInCategory;
		}
	}

	// progress can't be reversed (ie. if an answer triggers follow-ups)
	if (newProgressFillWidth < currentProgressFillWidth) {
		newProgressFillWidth = currentProgressFillWidth;
	}

	// complete all steps if we've completed the progress bar
	if (isComplete) {
		$('.js-progressbarstep').each(function () {
			if (!$(this).hasClass('is-complete')) {
				$(this).addClass('is-complete');
			}
		});
	} else if (!$currentStep.hasClass('is-complete')) {
		// complete the current step if hasn't been already
		$currentStep.addClass('is-complete');

		if (currentCategoryId > 1) {
			newProgressFillWidth += circleWidth;
		}
	}

	$('.js-progress')
		.val(newProgress)
		.attr('data-current-question', currentQuestionIndex);
	$('.js-progressbarstep-fill')
		.css('width', newProgressFillWidth);

	if (currentQuestionIndex > 1 && nextQuestionId) {
		let stateUrl = window.location.origin + '/checkup/' + currentQuestionIndex;
		if (window.location.href !== window.location.origin + '/checkup/' + currentQuestionIndex) {
			window.history.replaceState({}, '', stateUrl);
		}
	}
}

function updateQuestionIndexes() {
	let enabledQuestions = $('.js-question[data-question-enabled="true"]');

	for (var i = 0; i < enabledQuestions.length; i++) {
		$(enabledQuestions[i]).attr('data-question-index', i + 1);
	}
}

function tryPopulateQuestionDataFromLocalStorage() {
	if (localStorage.getItem(localStorageKey)) {
		try {
			let parsedLocalStorageData: Array<QuestionData> = JSON.parse(localStorage.getItem(localStorageKey));

			if (parsedLocalStorageData.length === 0) {
				throw "No question data";
			}

			// check that all the question ids are valid
			for (let i = 0; i < parsedLocalStorageData.length; i++) {
				var questionEl = $('.js-question[data-question-id="' + parsedLocalStorageData[i].id + '"]');

				if (questionEl.length !== 1) {
					throw "Corrupt question data";
				} else {
					questionEl.find('input').val(parsedLocalStorageData[i].data);
					trySaveQuestionData(parsedLocalStorageData[i].id);
				}
			}

			updateProgress();
		} catch (ex) {
			console.log(ex);

			// reset localStorage
			questionData = [];
			localStorage.setItem(localStorageKey, JSON.stringify(questionData));
			currentQuestionIndex = 1;
			window.history.replaceState({}, '', window.location.origin + '/checkup/');
		}
	}
}

function updateQuestionIndexFromUrl() {
	let urlPath = window.location.pathname;
	let questionIndex = parseInt(urlPath.substring(urlPath.lastIndexOf('/') + 1, window.location.pathname.length), 10);

	if (questionIndex > 0) {
		currentQuestionIndex = questionIndex;
	} else {
		currentQuestionIndex = 1;
	}
}

function applyCurrencyFormattingOnInput(el: JQuery) {
	el.on("keyup", function (event) {
		// strip commas before trying to convert to number
		var value = String(el.val()).replace(/[\,]+/g, '');
		var valueAsNumber = parseInt(value, 10);
		if (valueAsNumber > 0) {
			var fomattedValue = valueAsNumber.toLocaleString();
			el.val(fomattedValue);
		}
	});
}

function init() {
	// client name token update from server if found
	let clientFirstName = (window as any).clientFirstName || '';
	updateFirstName(clientFirstName);

	// reset everything
	questionData = [];
	localStorage.setItem(localStorageKey, JSON.stringify(questionData));
	currentQuestionIndex = 1;
	window.history.replaceState({}, '', window.location.origin + '/checkup/');
	$('.js-question input').val('');

	// the url might have a question index
	//updateQuestionIndexFromUrl();

	// populate fields from localStorage data
	//tryPopulateQuestionDataFromLocalStorage();

	// create question indexes
	updateQuestionIndexes();

	// currency input formatting
	$(currencyInputsSelector).each(function (index, el) {
		//applyCurrencyFormattingOnInput($(el));
	});

	// event handlers
	$('.js-questioninput--Occupation .js-questioninput').on('change keydown input', function (e) {
		occupationSuggestor.occupation_keyup(e, $(this));
	});
	$('.js-questioninput--Occupation .js-questioninput').on('focus', function (e) {
		occupationSuggestor.occupation_focus(null, $(this));
	});
	occupationSuggestor.occupation_init();
	$('.js-checkupform').on('submit', nextQuestion);
	$('.js-checkupcontainer').on('click', '.js-nextstep', nextQuestion);
	$('.js-checkupcontainer').on('keyup', '.js-questioninput', function (e) {
		let el = $(e.target);
		let elHasValue = el.val() !== '';
		let nextStepEl = el.parents('.js-question').find('.js-nextstep');

		if (elHasValue) {
			nextStepEl.removeAttr('disabled');
		} else {
			nextStepEl.attr('disabled', 'disabled');
		}
	});
	$('.js-question[data-question-type="10"]')
		.on('change, keyup', 'input[type="tel"], select', function (e) {
			var el = $(e.target).parents('.js-question').first();
			// strip commas before trying to convert to number
			var value = String(el.find('input[type="tel"]').val()).replace(/[\,]+/g, '');
			var amount = parseInt(value, 10);
			var frequency = parseInt(String(el.find('select').val()), 10);
			var monthlyAmount = amount;
			
			switch (frequency) {
				case 6:
					monthlyAmount = (amount * 52) / 12;
					break;

				case 5:
					monthlyAmount = (amount * 26) / 12;
					break;
			}

			el.find('.js-questionvalue').val(parseInt(String(monthlyAmount), 10));
		});

	// handle user going back
	$(window).on('popstate', function (e) {
		updateQuestionIndexFromUrl();
		let questionIdFromQuestionIndex = $('.js-question[data-question-index="' + currentQuestionIndex + '"]').attr('data-question-id');
		
		showQuestion(parseInt(questionIdFromQuestionIndex,10)|| firstQuestionsId);
	});

	// recalculate progress on window resize if we're not on the first question
	$(window).resize(function () {
		let currentQuestionEl = $('.js-question' + currentQuestionClassIdentifier);
		let currentQuestionId = parseInt(currentQuestionEl.attr('data-question-id'), 10);

		if (currentQuestionId != firstQuestionsId) {
			let nextQuestionId = parseInt(
				currentQuestionEl.nextAll('.js-question[data-question-enabled="true"]')
					.attr('data-question-id')
				, 10);

			updateProgress(nextQuestionId);
		}
	});

	$('.js-prompt--close-button, .js-manualsigninbtn').click(function (e) {
		$('.js-prompt').hide();
	});

	// handle actually starting the checkup from the initial list of insurance options
	$('.js-startcheckup').click(function () {
		$('.js-brand-hero-container').hide();
		$('.js-checkupheader').show();
        $('.js-checkupbody').removeClass('checkupbody--introstep');
        swapHeaders();
	});

	// show the first question or the question from the url
	let questionIdFromQuestionIndex = $('.js-question[data-question-index="' + currentQuestionIndex + '"]').attr('data-question-id');
	showQuestion(parseInt(questionIdFromQuestionIndex,10) || firstQuestionsId);
}

function swapHeaders() {
    $('.js-footer-small').removeClass('hidden');
    $('.js-footer-big').addClass('hidden');
}

init();